








import Vue from 'vue'
import { computed } from '@vue/composition-api'
import { defineClassComponent, useQuery } from '@/hooks'
import { Track } from '@/utils'

export default defineClassComponent(
  () =>
    class {
      constructor() {
        Track.useMark(() => ({
          page: '搜索',
        }))
      }

      loading = computed(() => false)

      query = useQuery<{
        pageType: string
        pageId: string
      }>()

      handleDataLoad = (payload: any) =>
        // @ts-ignore
        Vue.prototype.$dmbcApi.searchResource({
          ...payload,
          type: this.query.pageType,
          id: this.query.pageId,
        })
    },
)
